export default __webpack_public_path__ + "media/custom-branding.6e728abf.png";